import React, { useEffect, useState } from 'react';
import BookSection from '../Components/BookSection';
import axios from "axios";

const Books = () => {
 const [Data, setData]=useState();
 useEffect(()=>{
   const fetch= async () => {
    await axios.get("https://bookstore-backend-bk7y.onrender.com/api/v1/getBooks").then((res) => setData(res.data.books));
   };
   fetch();
 });
  return (
    <div className="booksection mb-0" style={{minHeight:"91.5vh",backgroundImage:"linear-gradient(0deg,#000, #03033f)"}}>
        <div className="d-flex justify-content-center align-items-center py-3">
        <h4 className="text-white">Books Section</h4>
    </div>
    {Data ? (
         <BookSection data={Data}/>
        ) : ( 
        <div className='text-white'>Loading....</div>

        )}
    </div>
  )
}

export default Books
